module.exports = __webpack_public_path__ + "img/image3.9da5b5e5.jpg";